<template>
  <v-container>
        <v-card class="profile" v-if="user">
          <v-card-title>
            <div>
                  <h3 class="headline mb-0">Settings</h3>
            </div>
          </v-card-title>
          <v-card-text>
                <v-text-field
                  class="py-3"
                  v-model="buffer.email"
                  :rules="emailRules"
                  label="Email"
                  :success="buffer.email != user.email"
                  :append-icon="buffer.email != user.email ? 'mdi-restore' : undefined"
                  :append-outer-icon="buffer.email != user.email ? 'mdi-floppy' : undefined"
                  @click:append="buffer.email = user.email"
                  @click:append-outer="updateEmail"
                  :messages="emailMessages"
                  disabled
                />
      </v-card-text>
          </v-card>
          <v-card class="mt-4" v-if="user && user.farmersWifeUser">
            <v-card-title>
              <div>
                    <h3 class="headline mb-0">Farmers Wife</h3>
              </div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                label="Username"
                :value="user.farmersWifeUser"
                disabled
              />
          </v-card-text>
            <v-card-text>
              <v-text-field
                type="password"
                label="Password"
                value="********"
                disabled
              />
          </v-card-text>
          <v-card-actions>
          <v-spacer />
                    <v-btn
                      :loading="deletingFarmersWifeCredentials"
                      text
                      color="error"
                      @click="deleteFarmersWifeCredentials"
                    >Forget credentials</v-btn>
                </v-card-actions>
          </v-card>
          <div style="display: flex;" class="my-4">
            <v-spacer />
            <v-dialog max-width="600px" v-model="deleteDialog">
              <template v-slot:activator="{ on }">
                  <v-btn color="error" v-on="on" disabled>
                    Delete account ...
                  </v-btn>
              </template>
              <v-card>
                <v-card-title
                  class="headline error white--text"
                  primary-title
                >
                  Delete account
                </v-card-title>

                <v-card-text class="py-3">
                  We will send you an email to confirm this action.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    @click="deleteDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    @click="deleteDialog = false"
                  >
                    OK
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
  </v-container>
</template>
<script>
export default {
  mounted() {
    this.resetBuffer();
  },
  data() {
    return {
      deleteDialog: false,
      deletingFarmersWifeCredentials: false,
      buffer: {
        email: '',
        ios: false,
        android: false,
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      emailMessages: [],
    };
  },
  computed: {
    user() {
      if (!this.$auth.state.uid) {
        return null;
      }
      Object.keys(this.buffer).forEach((k) => {
        this.$set(this.buffer, k, this.$store.state.users.all[this.$auth.state.uid][k]);
      });
      return this.$store.state.users.all[this.$auth.state.uid];
    },
    unlocked_for() {
      return this.$auth.state.recently_logged_in_for;
    },
    unlocked() {
      return this.unlocked_for > 0;
    },
  },
  methods: {
    deleteFarmersWifeCredentials() {
      this.deletingFarmersWifeCredentials = true;
      this.$store.dispatch('users/deleteWriteOnly', {
        user_uid: this.$auth.state.uid,
        docName: 'farmers-wife',
      }).then(() => {
        this.$store.dispatch('users/store', {
          uid: this.$auth.state.uid,
          farmersWifeUser: null,
        });
      }).catch((error) => {
        this.$store.commit('alerts/insert', { type: 'error', message: error });
        // alert(error);
      }).finally(() => {
        this.deletingFarmersWifeCredentials = false;
      });
    },
    resetBuffer() {
      if (!this.user) {
        return;
      }
      Object.keys(this.buffer).forEach((k) => {
        this.$set(this.buffer, k, this.user[k]);
      });
    },
    setProperty(field, value) {
      console.log(`setProperty: ${field} ${value}`);
      const data = { uid: this.user.uid };
      data[field] = value;
      this.$store.dispatch('users/store', data);
    },
    reauthenticateEmail() {
      this.$store.dispatch('auth/ReauthenticateEmail').then(() => {
        this.$store.commit('alerts/insert', {
          message: 'We have sent you an email to confirm your identify',
          type: 'info',
        });
      }).catch(error => this.$store.commit('alerts/insert', { type: 'error', message: error.message }));
    },
    lock() {
      this.$store.commit('users/insertOrUpdate', { uid: this.user.uid, recently_logged_in: 0 });
    },
    deleteUser() {
      this.$store.dispatch('auth/DeleteUser').then(this.$router.replace({ name: 'home' }));
    },
    updateEmail() {
      const { email } = this.buffer;
      this.$store.dispatch('auth/UpdateEmail', email).then(() => {
        this.buffer.email = email;
      }).catch(error => this.$store.commit('alerts/insert', { type: 'error', message: error.message }));
    },
  },
};
</script>
